import Badge from './Badge';

export default {
  id: 'radial_11',
  title: 'Radial_11',
  colors: 3,
  premium: true,
  BadgeComponentStateless: Badge
};
